import { Inject, Injectable } from '@angular/core';
import { get } from 'lodash';
import { EndorsementMeta } from '@lockton-apps/shared/interfaces';
import { ENDORSEMENT_META_DATA } from './endorsement-meta';

@Injectable()
export class EndorsementMetaService {
  private static placeholder: EndorsementMeta = {
    title: '...',
    template: {
      title: '',
      description: '',
    },
    previewHidden: true,
  };

  constructor(
    @Inject(ENDORSEMENT_META_DATA)
    private readonly endorsementMeta: Record<number, EndorsementMeta>
  ) {}

  get(type: number): EndorsementMeta {
    return get(this.endorsementMeta, type, EndorsementMetaService.placeholder);
  }
}
